/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Switch from "@mui/material/Switch";
import MDTypography from "components/MDTypography";
import StatusCell from "layouts/ecommerce/orders/order-list/components/StatusCell";

import Swal from "sweetalert2";

import { SpeedDial, SpeedDialAction } from "@mui/material";

import Box from "@mui/material/Box";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreIcon from "@mui/icons-material/More";
import EditIcon from "@mui/icons-material/Edit";
import InfoIcon from "@mui/icons-material/Info";

// Data
import { getAllNewsLetterMessagesApi, deleteNewsLetterMessageApi } from "api/messages";
import EventPlaces from "layouts/events/new-event/modals/Places";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import { getAllCategoriesApi } from "api/categories";
import { exportAllNewsLetterMessagesApi } from "api/messages";

function NewsLetterList() {
  const [menu, setMenu] = useState(null);
  const [tableRowData, setTableRowData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const PAGE_SIZE = 50;
  const [categoryData, setCategoryRowData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [selectedCity, setSelectedCity] = useState("");

  const [openModal, setOpenModal] = useState(false);
  const [openModalItemData, setOpenModalItemData] = useState("");

  const openMenu = (event) => setMenu(event.currentTarget);
  const closeMenu = () => setMenu(null);

  useEffect(() => {
    const init = async () => {
      try {
        const [, eventCategory] = await Promise.all([
          getTableData("", "", "", "", 0),
          getAllCategoriesApi(),
        ]);
        setCategoryRowData(eventCategory);
      } catch (err) {
        console.log(err);
      }
    };
    init();
  }, []);

  const handleCloseModal = (params) => {
    setOpenModal(false);
  };

  const handleEditeModal = (Data) => {
    setOpenModalItemData(Data);
    setOpenModal(true);
  };

  const getTableData = async (category, from, to, city, page = 0) => {
    try {
      const result = await getAllNewsLetterMessagesApi(category, from, to, city, page);
      setTableRowData(result.data);
      setTotalCount(result.totalCount);
      setCurrentPage(page);
    } catch (err) {
      console.log(err);
    }
  };

  const handleDeleteItem = async (ID) => {
    try {
      Swal.fire({
        title: "",
        text: "Voulez-vous vraiment supprimer",
        icon: "warning",
        confirmButtonText: "Supprimer",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await deleteNewsLetterMessageApi(ID);
            getTableData(selectedCategory || "", dateFrom, dateTo, selectedCity, currentPage);

            Swal.fire("Supprimée", "", "success");
          } catch (err) {
            console.log(err);
          }
        }
      });
    } catch (err) {
      console.log(err);
    }
  };

  const handleRefreshData = () => {
    getTableData(selectedCategory || "", dateFrom, dateTo, selectedCity, currentPage);
  };

  const handleDateFilter = (from, to) => {
    getTableData(selectedCategory || "", from, to, selectedCity, 0);
  };

  const handleClearDates = () => {
    setDateFrom("");
    setDateTo("");
    getTableData(selectedCategory || "", "", "", selectedCity, 0);
  };

  const handleSelectedEmails = () => {
    try {
    } catch (err) {
      console.log(err);
    }
  };

  const handleFilterNewLetter = (el) => {
    try {
      closeMenu()

      if(el === "all") {
        setSelectedCategory(null)
        return getTableData("", dateFrom, dateTo, selectedCity, 0);
      }
      setSelectedCategory(el.name)
      getTableData(el._id, dateFrom, dateTo, selectedCity, 0);
    }
    catch (err) {
      console.log(err);
    }
  }

  const handleExportData = async () => {
    try {
      const URL = await exportAllNewsLetterMessagesApi(selectedCategory ? selectedCategory : "", dateFrom, dateTo, selectedCity)
      window.open(URL, '_blank')
    }
    catch(err) {
      console.log(err);
    }
  }

  const renderMenu = (
    <Menu
      anchorEl={menu}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      open={Boolean(menu)}
      onClose={closeMenu}
      keepMounted
    >
      {categoryData.map((el) => (
        <MenuItem onClick={() => handleFilterNewLetter(el)}>{el.name}</MenuItem>
      ))}
      <Divider sx={{ margin: "0.5rem 0" }} />
      <MenuItem onClick={() => handleFilterNewLetter("all")}>
        <MDTypography variant="button" color="success" fontWeight="regular">
          Tous
        </MDTypography>
      </MenuItem>
    </Menu>
  );

  return (
    <DashboardLayout>
      <EventPlaces
        openEventPlace={openModal}
        closeEventPlace={handleCloseModal}
        refreshData={handleRefreshData}
        isEdite={true}
        openModalItemData={openModalItemData}
      />
      <DashboardNavbar />
      <MDBox my={3}>
        <MDBox display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}></MDBox>
        <Card>
        <MDBox display="flex" justifyContent="space-between" alignItems="center" padding={2} flexWrap="wrap" gap={1}>
          <MDBox display="flex" alignItems="center" gap={1} flexWrap="wrap">
            <TextField
              label="De"
              type="date"
              size="small"
              value={dateFrom}
              onChange={(e) => {
                setDateFrom(e.target.value);
                handleDateFilter(e.target.value, dateTo);
              }}
              InputLabelProps={{ shrink: true }}
              sx={{ width: 160 }}
            />
            <TextField
              label="À"
              type="date"
              size="small"
              value={dateTo}
              onChange={(e) => {
                setDateTo(e.target.value);
                handleDateFilter(dateFrom, e.target.value);
              }}
              InputLabelProps={{ shrink: true }}
              sx={{ width: 160 }}
            />
            {(dateFrom || dateTo) && (
              <MDButton variant="text" color="error" size="small" onClick={handleClearDates}>
                <Icon>close</Icon>&nbsp;Effacer
              </MDButton>
            )}
            <TextField
              label="Ville"
              type="text"
              size="small"
              value={selectedCity}
              onChange={(e) => {
                setSelectedCity(e.target.value);
                getTableData(selectedCategory || "", dateFrom, dateTo, e.target.value, 0);
              }}
              sx={{ width: 160 }}
            />
          </MDBox>
          <MDBox display="flex" alignItems="center" gap={1}>
            <MDButton
              variant={menu ? "contained" : "outlined"}
              color="dark"
              onClick={openMenu}
            >
              {selectedCategory ? selectedCategory : "filters par type d'événement"}
              <Icon>keyboard_arrow_down</Icon>
            </MDButton>
            {renderMenu}
            <MDButton variant="outlined" color="dark" onClick={() => handleExportData()}>
              <Icon>description</Icon>
              &nbsp;export csv
            </MDButton>
          </MDBox>
        </MDBox>

          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead style={{ display: "table-header-group", important: "true" }}>
                <TableRow>
                  <TableCell
                    align="left"
                    style={{
                      color: "#7b809a",
                      fontSize: "0.7rem",
                      opacity: "0.7",
                      textTransform: "uppercase",
                    }}
                  >
                    Selectionnée
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{
                      color: "#7b809a",
                      fontSize: "0.7rem",
                      opacity: "0.7",
                      textTransform: "uppercase",
                    }}
                  >
                    Date
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{
                      color: "#7b809a",
                      fontSize: "0.7rem",
                      opacity: "0.7",
                      textTransform: "uppercase",
                    }}
                  >
                    Ville
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{
                      color: "#7b809a",
                      fontSize: "0.7rem",
                      opacity: "0.7",
                      textTransform: "uppercase",
                    }}
                  >
                    Téléphone
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{
                      color: "#7b809a",
                      fontSize: "0.7rem",
                      opacity: "0.7",
                      textTransform: "uppercase",
                    }}
                  >
                    Email
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{
                      color: "#7b809a",
                      fontSize: "0.7rem",
                      opacity: "0.7",
                      textTransform: "uppercase",
                    }}
                  >
                    Catégories
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tableRowData.map((el, index) => (
                  <TableRow key="index" sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                    <TableCell
                      align="left"
                      style={{
                        color: "#7b809a",
                        fontSize: "0.8rem",
                        fontWeight: "600",
                        maxWidth: 100,
                      }}
                    >
                      <Switch onChange={() => handleSelectedEmails(el._id, el.isSelected)} />
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        color: "#7b809a",
                        fontSize: "0.8rem",
                        fontWeight: "600",
                        maxWidth: 100,
                      }}
                    >
                      <p>{el.createdAt.substr(0, 16).split('T')[0]} {el.createdAt.substr(0, 16).split('T')[1]}</p>
                    </TableCell>

                    <TableCell
                      align="left"
                      style={{
                        color: "#7b809a",
                        fontSize: "0.8rem",
                        fontWeight: "600",
                        maxWidth: 100,
                      }}
                    >
                      <p>{el?.city}</p>
                    </TableCell>

                    <TableCell
                      align="left"
                      style={{
                        color: "#7b809a",
                        fontSize: "0.8rem",
                        fontWeight: "600",
                        maxWidth: 100,
                      }}
                    >
                      <p>{el?.phone}</p>
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        color: "#7b809a",
                        fontSize: "0.8rem",
                        fontWeight: "600",
                        maxWidth: 100,
                      }}
                    >
                      <p>{el.email}</p>
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        color: "#7b809a",
                        fontSize: "0.8rem",
                        fontWeight: "600",
                        maxWidth: 100,
                      }}
                    >
                      <p>
                        {el.eventCategory.map((el) => (
                          <p key={el._id}>*{el.name}</p>
                        ))}
                      </p>
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        color: "#7b809a",
                        fontSize: "0.8rem",
                        fontWeight: "600",
                        maxWidth: 100,
                      }}
                    >
                      <Box sx={{ height: 80, transform: "translateZ(0px)" }}>
                        <SpeedDial
                          ariaLabel="SpeedDial basic example"
                          sx={{ position: "absolute", top: 0, right: "60%" }}
                          className="custom-speed-dial"
                          icon={<MoreIcon />}
                          direction="left"
                        >
                          {/* <SpeedDialAction
                            key={""}
                            icon={<InfoIcon />}
                            tooltipTitle="details"
                            onClick={() => handleEditeModal(el)}
                          /> */}
                          <SpeedDialAction
                            key={""}
                            icon={<DeleteIcon />}
                            tooltipTitle="Supprimer"
                            onClick={() => handleDeleteItem(el._id)}
                          />
                        </SpeedDial>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {totalCount > PAGE_SIZE && (
            <MDBox display="flex" justifyContent="space-between" alignItems="center" padding={2}>
              <MDTypography variant="caption" color="text">
                {currentPage * PAGE_SIZE + 1}–{Math.min((currentPage + 1) * PAGE_SIZE, totalCount)} sur {totalCount}
              </MDTypography>
              <MDBox display="flex" alignItems="center" gap={1}>
                <MDButton
                  variant="outlined"
                  color="dark"
                  size="small"
                  disabled={currentPage === 0}
                  onClick={() => getTableData(selectedCategory || "", dateFrom, dateTo, selectedCity, currentPage - 1)}
                >
                  <Icon>chevron_left</Icon>
                </MDButton>
                <MDTypography variant="caption" color="text">
                  Page {currentPage + 1} / {Math.ceil(totalCount / PAGE_SIZE)}
                </MDTypography>
                <MDButton
                  variant="outlined"
                  color="dark"
                  size="small"
                  disabled={(currentPage + 1) * PAGE_SIZE >= totalCount}
                  onClick={() => getTableData(selectedCategory || "", dateFrom, dateTo, selectedCity, currentPage + 1)}
                >
                  <Icon>chevron_right</Icon>
                </MDButton>
              </MDBox>
            </MDBox>
          )}
        </Card>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default NewsLetterList;
